import styled from "styled-components";
import {shadeOrLighten} from "@dropDesk/utils/helpers/colors";

type ContainerType = {
    background: string;
    isDarkenBackground?: boolean;
}


type LineClampTextType = {
    color: string;
    height: number;
    width: number;
}

type ContainerAvatarType = {
    width: number;
}

type BorderType = {
    bordercolor: string;
}


export const Container = styled.div<ContainerType>`
    display: flex;
    flex: 1;
    height: 72px;
    min-height: 72px;
    max-height: 72px;
    flex-direction: row;
    cursor: pointer;
    background: ${props => props.isDarkenBackground ?
            shadeOrLighten(props.background, -40) : props.background};

    &:hover {
        background: ${props => shadeOrLighten(props.background, -40)};
    }
`;

export const ContainerAvatar = styled.div<ContainerAvatarType>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: ${(props) => `${props.width}px`};
    max-width: ${(props) => `${props.width}px`};
    min-width: ${(props) => `${props.width}px`};
`;
export const ContainerData = styled.div<BorderType>`
    display: flex;
    flex-basis: auto;
    flex-direction: row;
    flex-grow: 1;
    justify-content: center;
    min-width: 0;
    padding: 0px 10px 0px 0px;
    border-bottom: 1px solid ${props => props.bordercolor};
`;

export const ContentLineClamp = styled.div<LineClampTextType>`
    display: block;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    color: ${props => props.color};
    max-height: ${(props) => `${props.height}px`};
    height: ${(props) => `${props.height}px`};
    max-width: ${(props) => `${props.width}px`};
    white-space: nowrap;
`;
export const ContentName = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
`;
